enum RECEIVE_ACTION_TYPE {
  NORMAL = 0,
  BENHNHANMOI = 1,
  PHIEUKHAMMOI = 2,
  EDITPHIEUKHAM = 3,
  EDITGIAHANTHE = 4,
  HUYKHAM = 5,
  REMOVE_RECEIVED_ROW = 7,
  REMOVE_PATIENT_CARD_ROW = 8,
  CLEARFIELDS = 9,
  RELOAD = 10
}

export {RECEIVE_ACTION_TYPE};